import {useEffect, useState} from "react";
import {Field, Formik} from "formik"
import {useKeycloak} from "@react-keycloak/web";

import Fields from "../formFields"
import UTILS from '../../utils';
import Blocks from "../blocks";
import LoginBG from "../../assets/images/study-login.svg";

const phoneIcon = require("../../assets/images/phone.png")
const googleIcon = require("../../assets/images/google-logo.png")
const facebookIcon = require("../../assets/images/facebook-logo.png")

const PageLogin = () => {
  const [isPasswordVisible, toggle] = useState(false);
  const { keycloak } = useKeycloak();

  useEffect(() => {
    if (!keycloak.authenticated) {
      keycloak.login({ redirectUri: window.location.href + "/" });
    }
  }, []);
  const handleToggle = () => {
    toggle((prev) => !prev);
  };
  return (
    <div className={"page PageLogin"}>
      <h1
        className={
          "mb-4 text-center text-sm sm:text-lg md:text-4xl pt-16 md:pt-4 font-heading"
        }
      >
        {" "}
        “A teacher is person who sows the seed of wisdom in mind”
      </h1>
      <div className="container mx-auto">
        <div className="flex flex-col md:flex-row items-center">
          <div className="bgWrapper md:flex justify-center items-center bg-white">
            <img src={LoginBG} alt="" />
          </div>
          <div className="pageContent w-full max-w-lg mx-auto md:mr-0 md:ml-auto  mb-4 bg-white p-4 rounded-xl">
            <h1 className={"mb-4 text-center text-xl md:text-4xl font-heading"}>
              Log In{" "}
            </h1>
            <Blocks.ErrorBoundary>
              <Formik
                initialValues={{ email: "", password: "", firstName: "raj" }}
                validationSchema={UTILS.forms.LoginSchema}
                onSubmit={(values, { setSubmitting }) => {
                  setSubmitting(false);
                }}
              >
                {({ handleSubmit, isSubmitting, errors }) => (
                  <form onSubmit={handleSubmit} className="pt-6 pb-8">
                    <Field
                      type="email"
                      name="email"
                      placeholder="Email Id"
                      iconBefore={<i className={`text-xl icon icon-mail1`}></i>}
                      error={errors.email}
                      component={Fields.FieldInput}
                    />
                    <Field
                      type={!isPasswordVisible ? "password" : "text"}
                      name="password"
                      placeholder="Password"
                      iconBefore={
                        <i className={`text-xl icon icon-unlock`}></i>
                      }
                      iconAfter={
                        <i
                          className={`text-xl cursor-pointer icon icon-${
                            !isPasswordVisible ? "eye-off" : "eye"
                          }`}
                          onClick={() => handleToggle()}
                        ></i>
                      }
                      error={errors.password}
                      wrapperClasses={"-mb-0"}
                      component={Fields.FieldInput}
                    />
                    <p className="text-right text-xs mb-6">
                      <a
                        href="#"
                        className={"text-red-500 underline decoration-solid"}
                      >
                        Forgot password
                      </a>
                    </p>

                    <button
                      disabled={isSubmitting}
                      className="bg-black w-full hover:bg-slate-600 text-white font-bold py-3 px-4 rounded focus:outline-none focus:shadow-outline"
                      type="submit"
                    >
                      Log In
                    </button>
                  </form>
                )}
              </Formik>

              <p className={"text-center mb-6"}>
                or <span className="md:hidden">login with</span>
              </p>

              <div
                className={
                  "flex justify-between md:flex-col w-3/5 md:w-full mx-auto"
                }
              >
                <button
                  className={
                    "flex justify-around items-center w-fit md:w-full bg-white md:shadow md:rounded-lg p-3 mb-6"
                  }
                >
                  <img
                    src={phoneIcon}
                    className={"h-10 w-10 md:h-5 md:w-5"}
                    alt="Phone icon"
                  />
                  <span className={"hidden md:block text-center"}>
                    Log In with Mobile Number
                  </span>
                  <span className="hidden md:block h-8 w-8"></span>
                </button>
                <button
                  className={
                    "flex justify-around items-center w-fit md:w-full bg-white md:shadow md:rounded-lg p-3 mb-6"
                  }
                >
                  <img
                    src={facebookIcon}
                    className={"h-10 w-10 md:h-5 md:w-5"}
                    alt="Phone icon"
                  />
                  <span className={"hidden md:block text-center"}>
                    Log In with Facebook
                  </span>
                  <span className="hidden md:block h-8 w-8"></span>
                </button>
                <button
                  className={
                    "flex justify-around items-center w-fit md:w-full bg-white md:shadow md:rounded-lg p-3 mb-6"
                  }
                >
                  <img
                    src={googleIcon}
                    className={"h-10 w-10 md:h-5 md:w-5"}
                    alt="Phone icon"
                  />
                  <span className={"hidden md:block text-center"}>
                    Log In with Google
                  </span>
                  <span className="hidden md:block h-8 w-8"></span>
                </button>
              </div>

              <p className={"text-center"}>
                Don’t have an account? If you are a teacher{" "}
                <a href="#" className={"underline decoration-solid"}>
                  click here
                </a>
                &nbsp; If you are a student Kindly ask for the invite from your
                teacher
              </p>
            </Blocks.ErrorBoundary>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PageLogin
